import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormControlLabel,
  TextField,
  Checkbox,
  IconButton,
  Radio,
} from "@mui/material";
import { ReactComponent as ArrowbackIcon } from "../../Assets/arrowback.svg";
import Grid from "@mui/material/Grid2";
import {
  createViewPort,
  editViewPort,
  getViewExitPortData,
} from "../../Services/ExperienceApi";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

function EditViewPort() {
  const [titleError, setTitleError] = useState(false);
  const [title, setTitle] = useState("Viewport Exit");
  const location = useLocation();
  const fullViewExitId = location.state?.data.id;
  const viewExitId = fullViewExitId?.split("_")[1];
  const sessionData = sessionStorage.getItem("pendingNodeAddition");
  const sessionObj = sessionData ? JSON.parse(sessionData) : {};
  const experienceId =
    location.state?.data.experinceId || sessionObj.experinceId;
  const fullSegmentId = location.state?.data.segmentId || sessionObj.segmentId;
  const segmentId = location.state?.data.segmentId
    ? fullSegmentId.split("_")[1]
    : fullSegmentId;
  const navigate = useNavigate();

  const icons = [
    {
      id: 1,
      label: "All sides",
      value: "all_sides",
      description: "Trigger event when mouse exits any side of the viewport",
      svg: (
        <svg
          width="100"
          height="100"
          viewBox="0 0 100 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 18H88C88.5304 18 89.0391 18.2107 89.4142 18.5858C89.7893 18.9609 90 19.4696 90 20V80C90 80.5304 89.7893 81.0391 89.4142 81.4142C89.0391 81.7893 88.5304 82 88 82H12C11.4696 82 10.9609 81.7893 10.5858 81.4142C10.2107 81.0391 10 80.5304 10 80V20C10 19.4696 10.2107 18.9609 10.5858 18.5858C10.9609 18.2107 11.4696 18 12 18ZM12 24H88V79C88 79.2652 87.8946 79.5196 87.7071 79.7071C87.5196 79.8946 87.2652 80 87 80H13C12.7348 80 12.4804 79.8946 12.2929 79.7071C12.1054 79.5196 12 79.2652 12 79V24Z"
            fill="url(#paint0_linear)"
          ></path>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15 26H85L81 30H19L15 26ZM15 78H85L81 74H19L15 78ZM14 27V77L18 73V31L14 27ZM86 27V77L82 73V31L86 27Z"
            fill="url(#paint1_linear)"
          ></path>
          <defs>
            <linearGradient
              id="paint0_linear"
              x1="10"
              y1="50"
              x2="90"
              y2="50"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#777D90"></stop>
              <stop offset="1" stop-color="#656B80"></stop>
            </linearGradient>
            <linearGradient
              id="paint1_linear"
              x1="86"
              y1="52"
              x2="14"
              y2="52"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#1C2544"></stop>
              <stop offset="1" stop-color="#454D66"></stop>
            </linearGradient>
          </defs>
        </svg>
      ),
    },
    {
      id: 2,
      label: "Top side only",
      value: "top_side",
      description:
        "Trigger event only when mouse leaves the top of the viewport",
      svg: (
        <svg
          width="100"
          height="100"
          viewBox="0 0 100 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 18H88C88.5304 18 89.0391 18.2107 89.4142 18.5858C89.7893 18.9609 90 19.4696 90 20V80C90 80.5304 89.7893 81.0391 89.4142 81.4142C89.0391 81.7893 88.5304 82 88 82H12C11.4696 82 10.9609 81.7893 10.5858 81.4142C10.2107 81.0391 10 80.5304 10 80V20C10 19.4696 10.2107 18.9609 10.5858 18.5858C10.9609 18.2107 11.4696 18 12 18ZM12 24H88V79C88 79.2652 87.8946 79.5196 87.7071 79.7071C87.5196 79.8946 87.2652 80 87 80H13C12.7348 80 12.4804 79.8946 12.2929 79.7071C12.1054 79.5196 12 79.2652 12 79V24Z"
            fill="url(#paint0_linear)"
          ></path>
          <defs>
            <linearGradient
              id="paint0_linear"
              x1="10"
              y1="50"
              x2="90"
              y2="50"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#777D90"></stop>
              <stop offset="1" stop-color="#656B80"></stop>
            </linearGradient>
          </defs>
        </svg>
      ),
    },
  ];

  const [selectedIcon, setSelectedIcon] = useState<any>("all_sides");
  const [backSelectionEnabled, setBackSelectionEnabled] = useState(false);
  const handleSelect = (value: any) => {
    setSelectedIcon(value);
  };

  useEffect(() => {
    const fetchExperience = async () => {
      if (segmentId && experienceId && viewExitId) {
        const response = await getViewExitPortData(
          experienceId,
          segmentId,
          viewExitId
        );
        if (response.success === true && response) {
          const ViewExitData = response.viewport_exit_setting;
          setTitle(ViewExitData.title);
          setSelectedIcon(ViewExitData.desktop_exit_side);
          setBackSelectionEnabled(ViewExitData.mobile_back_button_enabled);
        }
      }
    };
    fetchExperience();
  }, [segmentId, experienceId, viewExitId]);
  const handleSave = async () => {
    const payload = {
      title: title,
      desktop_exit_side: selectedIcon,
      mobile_back_button_enabled: backSelectionEnabled,
    };
    let response;
    if (viewExitId) {
      response = await editViewPort(
        experienceId,
        segmentId,
        viewExitId,
        payload
      );
    } else {
      response = await createViewPort(experienceId, segmentId, payload);
    }
    if (response.success === true) {
      toast.success(response.message);
      navigate(-1);
    } else {
      toast.error(response.error);
    }
  };
  const onback = () => {
    navigate(-1);
  };
  return (
    <div className="templates">
      <Grid container className="templates__header">
        <Grid
          size={{ xs: 12, md: 3, sm: 6 }}
          className="templates__header--search"
        >
          <div className="d-center">
            <span className="Icon">
              <IconButton aria-label="close" onClick={onback}>
                <ArrowbackIcon />
              </IconButton>{" "}
            </span>{" "}
            <h2 className="mb-0"> Viewport Exit</h2>{" "}
          </div>
        </Grid>
        <Grid
          size={{ xs: 12, md: 9, sm: 6 }}
          className="templates__header--button "
        >
          <Box className="button-heading">
            <Button
              className="button"
              sx={{
                "--variant-containedBg": "rgba(228, 0, 43, 1)",
                "&:hover": {
                  "--variant-containedBg": "rgba(228, 0, 43, 1)",
                  "--variant-textBg": "rgba(228, 0, 43, 0.04)",
                },
              }}
              variant="contained"
              color="error"
              onClick={handleSave}
            >
              Save
            </Button>
            <Button
              sx={{
                "--variant-outlinedBorder": "rgba(228, 0, 43, 1)",
                "--variant-outlinedColor": "rgba(228, 0, 43, 1)",
                "--variant-containedBg": "rgba(228, 0, 43, 1)",

                "&:hover": {
                  "--variant-outlinedBorder": "rgba(228, 0, 43, 1)",
                  "--variant-outlinedBg": "rgba(228, 0, 43, 0.04)",
                  "--variant-containedBg": "rgba(228, 0, 43, 1)",
                  "--variant-textBg": "rgba(228, 0, 43, 0.04)",
                },
              }}
              variant="outlined"
              onClick={onback}
            >
              Cancel
            </Button>
          </Box>
        </Grid>
      </Grid>

      <Box className="editSegment__container viewport" mt={2}>
        <Grid container spacing={{ xs: 0, sm: 0, md: 2 }} alignItems={"center"}>
          <Grid size={{ xs: 12, md: 2, sm: 6 }}>
            <div className="editSegment__container--heading">
              <h2>TITLE OF CARD :</h2>
            </div>
          </Grid>
          <Grid
            size={{ xs: 12, md: 8, sm: 6 }}
            className="editSegment__container--heading"
          >
            <TextField
              variant="standard"
              fullWidth
              required
              value={title}
              error={titleError}
              helperText={titleError ? "Title is required" : ""}
              onChange={(e) => {
                const value = e.target.value;
                setTitle(value);
                if (value.trim()) {
                  setTitleError(false); // clear error if input becomes valid
                }
              }}
            />
          </Grid>
        </Grid>
      </Box>
      <Box className="editSegment__container viewport" mt={2} p={2}>
        <h4> DESKTOP PROPERTIES </h4>
        <Grid
          container
          spacing={{ xs: 0, sm: 0, md: 4 }}
          mt={2}
          justifyContent={"center"}
          p={2}
        >
          {icons.map(({ id, svg, label, description, value }) => (
            <Grid size={{ xs: 12, md: 3, sm: 6 }} key={id}>
              <Box
                className="viewport_box"
                bgcolor={selectedIcon === id ? "#ffe5e5" : "transparent"}
                onClick={() => handleSelect(id)}
              >
                <Box className="viewport_box--icon" gap={1} py={3} px={2}>
                  <IconButton>{svg}</IconButton>
                </Box>

                <Box px={3} py={2} className="viewport_box--description">
                  <FormControlLabel
                    control={
                      <Radio
                        className="radio_label"
                        sx={{
                          color: "rgb(228, 0, 43)",
                          "&.Mui-checked": {
                            color: "rgb(228, 0, 43)",
                          },
                        }}
                        checked={selectedIcon === value}
                        onChange={() => handleSelect(value)}
                        value={value}
                        name="icon-radio"
                      />
                    }
                    label={<span className="radio_label_text">{label}</span>}
                  />
                  <p>{description}</p>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>

      <Box className="editSegment__container viewport" mt={2} p={2}>
        <h4> MOBILE PROPERTIES </h4>
        <Grid
          container
          spacing={{ xs: 0, sm: 0, md: 4 }}
          mt={2}
          justifyContent={"center"}
          p={2}
        >
          <Grid size={{ xs: 12, md: 3, sm: 6 }}>
            <Box className="viewport_box">
              <Box className="viewport_box--icon" gap={1} py={3} px={2}>
                <IconButton>
                  <svg
                    width="220"
                    height="135"
                    viewBox="0 0 220 135"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M90 36C88.8954 36 88 36.8954 88 38V98C88 99.1046 88.8954 100 90 100H126C127.105 100 128 99.1046 128 98V38C128 36.8954 127.105 36 126 36H90ZM126 42H90V98H126V42Z"
                      fill="url(#paint0_linear)"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M112 62L110 60L104 66L102 68L104 70L110 76L112 74L106 68L112 62Z"
                      fill="url(#paint1_linear)"
                    ></path>
                    <defs>
                      <linearGradient
                        id="paint0_linear"
                        x1="88"
                        y1="68"
                        x2="128"
                        y2="68"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#777D90"></stop>
                        <stop offset="1" stop-color="#656B80"></stop>
                      </linearGradient>
                      <linearGradient
                        id="paint1_linear"
                        x1="112"
                        y1="68"
                        x2="102"
                        y2="68"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#1C2544"></stop>
                        <stop offset="1" stop-color="#454D66"></stop>
                      </linearGradient>
                    </defs>
                  </svg>
                </IconButton>
              </Box>
              <Box px={3} py={2} className="viewport_box--description">
                <FormControlLabel
                  sx={{
                    marginBottom: "10px",
                  }}
                  className="check_box"
                  value="end"
                  control={
                    <Checkbox
                      checked={backSelectionEnabled}
                      onChange={(e) =>
                        setBackSelectionEnabled(e.target.checked)
                      }
                    />
                  }
                  label={
                    <span className="radio_label_text">Back selection</span>
                  }
                  labelPlacement="end"
                />
                <p>
                  Trigger event when users select the back button on mobile web
                  browsers
                </p>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default EditViewPort;
